import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreLink,
  moreText = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="min-w-0">
        <div className="flex items-center gap-2.5">
          <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950">{title}</h2>
        </div>
        {subtitle && <p className="mt-2 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="shrink-0 flex items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap"
        >
          {moreText}
          <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}